import * as Yup from "yup"

const validation_schema = Yup.object({
  newPass: Yup.string()
    .required()
    .min(8, "Hasło jest za krótkie"),
  newPassRepeat: Yup.string().required("Powtórz hasło").oneOf(
    [Yup.ref("newPass")],
    "Hasło nie jest identyczne"
  ),
})

export default validation_schema
